// extracted by mini-css-extract-plugin
module.exports = {"tokens":"videoBlocks_tokens__JInGP","collection":"videoBlocks_collection__Eengk","playlist":"videoBlocks_playlist__w6hKT","videoBlocks":"videoBlocks_videoBlocks__HiHD0"};